package com.cs.ejobin.ui.screens.auth

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import com.cs.ejobin.i18n.Keys
import com.cs.ejobin.i18n.t
import com.cs.ejobin.ui.components.ErrorText
import com.cs.ejobin.ui.components.ScreenScaffold
import com.cs.ejobin.ui.theme.AppColors
import com.cs.ejobin.ui.theme.AppSurfaces
import com.cs.ejobin.vm.ForgotPasswordViewModel
import ejobin.composeapp.generated.resources.Res
import ejobin.composeapp.generated.resources.eJobin_logo
import org.jetbrains.compose.resources.painterResource

@Composable
fun ForgotPasswordScreen(
    vm: ForgotPasswordViewModel,
    onEmailSent: () -> Unit,
    onBack: () -> Unit
) {
    val state by vm.state.collectAsState()

    val primaryTextButtonColors = ButtonDefaults.textButtonColors(
        contentColor = AppColors.Primary
    )

    ScreenScaffold(
        title = "",
        scrollable = true,
        topActions = {}
    ) {
        Column(
            modifier = Modifier.fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Spacer(Modifier.height(18.dp))

            Image(
                painter = painterResource(Res.drawable.eJobin_logo),
                contentDescription = "EJobin",
                modifier = Modifier.size(110.dp)
            )

            Spacer(Modifier.height(18.dp))

            Card(
                modifier = Modifier
                    .fillMaxWidth()
                    .widthIn(max = 520.dp),
                colors = AppSurfaces.glassCard(),
                border = CardDefaults.outlinedCardBorder()
            ) {
                Column(
                    modifier = Modifier.padding(18.dp),
                    verticalArrangement = Arrangement.spacedBy(12.dp)
                ) {
                    Text(
                        text = t(Keys.forgot_password),
                        style = MaterialTheme.typography.titleLarge,
                        color = AppColors.TextPrimary
                    )

                    Text(
                        text = t(Keys.forgot_subtitle),
                        style = MaterialTheme.typography.bodyMedium,
                        color = AppColors.TextPrimary
                    )

                    OutlinedTextField(
                        value = state.email,
                        onValueChange = vm::onEmail,
                        modifier = Modifier.fillMaxWidth(),
                        singleLine = true,
                        enabled = !state.isLoading,
                        label = { Text(t(Keys.email)) },
                        keyboardOptions = KeyboardOptions(
                            keyboardType = KeyboardType.Email,
                            imeAction = ImeAction.Done
                        ),
                        keyboardActions = KeyboardActions(
                            onDone = {
                                if (!state.isLoading) vm.sendResetEmail(onNext = onEmailSent)
                            }
                        )
                    )

                    ErrorText(state.errorKey)

                    Button(
                        onClick = { vm.sendResetEmail(onNext = onEmailSent) },
                        modifier = Modifier.fillMaxWidth(),
                        enabled = !state.isLoading,
                        colors = ButtonDefaults.buttonColors(containerColor = AppColors.Primary)
                    ) {
                        if (state.isLoading) {
                            CircularProgressIndicator(
                                modifier = Modifier.size(18.dp),
                                strokeWidth = 2.dp,
                                color = MaterialTheme.colorScheme.onPrimary
                            )
                            Spacer(Modifier.width(10.dp))
                            Text(t(Keys.loading))
                        } else {
                            Text(t(Keys.forgot_send_link))
                        }
                    }

                    TextButton(
                        onClick = onBack,
                        enabled = !state.isLoading,
                        colors = primaryTextButtonColors
                    ) {
                        Text(t(Keys.forgot_back))
                    }
                }
            }

            Spacer(Modifier.height(18.dp))
        }
    }
}